// 接口的数据库名、标签名和筛选值统一映射为展示名称。
const LIST_ALIASES = {
  Tranco: ["tranco", "trancotop1mdomains", "tranco_top1m"],
  Secrank: ["secrank", "secrank_domains", "secrank_top1m"],
  Cloudflare: ["cloudflare", "cloudflare_domains", "cf_top1m"],
  全球govedu: ["edugov", "govedu", "全球govedu"],
  国内重要机构: ["company", "company_domains", "institutional", "domestic", "国内重要机构"]
};
const RANKED_LISTS = ["Tranco", "Secrank", "Cloudflare"];
const AFFILIATION_LISTS = ["全球govedu", "国内重要机构"];

function getListName(value) {
  const raw = String(value || "").trim().toLowerCase();

  return Object.keys(LIST_ALIASES).find(name => LIST_ALIASES[name].includes(raw)) || "";
}

function getEntryListName(entry) {
  if (typeof entry === "string") {
    return getListName(entry);
  }
  if (!entry) {
    return "";
  }
  return getListName(entry.list) || getListName(entry.label) || getListName(entry.name);
}

function getMetadataListNames(metadata) {
  const entries = [
    ...(metadata.lists || []),
    ...(metadata.list_ranks || []),
    ...(metadata.list_tags || []),
    metadata.best_list_name,
    metadata.best_list_label
  ];

  return Array.from(new Set(entries.map(getEntryListName).filter(Boolean)));
}

export function formatDomainListMetadata(metadata) {
  return metadata ? getMetadataListNames(metadata).join("、") || "—" : "—";
}

function getAffiliationNote(tag) {
  if (!tag || typeof tag !== "object") {
    return "";
  }

  const name = getEntryListName(tag);

  if (!AFFILIATION_LISTS.includes(name)) {
    return "";
  }
  if (tag.note) {
    return tag.note;
  }
  if (name === "国内重要机构") {
    return tag.org || "";
  }

  const country = tag.country_zh || tag.country_en;
  const type = { edu: "教育", gov: "政府" }[tag.type];

  return country && type ? `${country}（${type}）` : "";
}

export function formatBestListRank(metadata) {
  if (!metadata) {
    return "—";
  }

  // 政府、教育和机构列表的行号不是热度排名，优先展示其归属说明。
  const notes = (metadata.list_tags || []).map(getAffiliationNote).filter(Boolean);

  if (notes.length) {
    return Array.from(new Set(notes)).join("、");
  }

  const affiliations = getMetadataListNames(metadata).filter(name => AFFILIATION_LISTS.includes(name));

  if (affiliations.length) {
    return affiliations.join("、");
  }

  const ranks = [
    ...(metadata.list_ranks || []),
    { list: metadata.best_list_name, label: metadata.best_list_label, rank: metadata.best_list_rank }
  ].map(item => ({ name: getEntryListName(item), rank: Number(item.rank) }))
    .filter(item => RANKED_LISTS.includes(item.name) && Number.isFinite(item.rank) && item.rank > 0)
    .sort((a, b) => a.rank - b.rank);

  return ranks.length ? `${ranks[0].name} 第${ranks[0].rank}名` : "—";
}
